import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HisBackendService } from 'hisng';
import { JobAdvertisement } from 'app/rm/erp/jobadvertisement/model/jobadvertisement';
import { ErpDocumentService } from 'app/rm/erp/common/document/service/erp-document-service';

@Injectable()
export class JobAdvertisementService {
    constructor(
        private readonly hisBackendService: HisBackendService,
        private readonly erpDocumentService: ErpDocumentService
    ) { }

    getById( id: number ): Observable<JobAdvertisement> {
        return this.hisBackendService.getData( 'api/v1/rm/erp/jobadvertisement/' + id );
    }

    checkJobApplicationPossible( id: number ): Observable<void> {
        return this.hisBackendService.getData( 'api/v1/rm/erp/jobadvertisement/' + id + '/checkapplicationpossible' );
    }

    downloadJobAdvertisementDocument( id: number ) {
        this.erpDocumentService.downloadDocument( '../../api/v1/rm/erp/jobadvertisement/document/' + id );
    }
}
